"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPdfFile = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconPdfFile = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M20.465 8.323V13h-2.15V9.261l-4.95-4.95H6.423a.294.294 0 0 0-.212.096.294.294 0 0 0-.096.212V13h-2.15V4.619c0-.684.239-1.264.716-1.742a2.37 2.37 0 0 1 1.742-.716h7.88l6.162 6.162Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.047 14.875H3.25v7.283h1.737v-2.502h1.06c1.45 0 2.516-1.015 2.516-2.406 0-1.382-1.067-2.375-2.516-2.375Zm.77 2.375c0 .418-.32.73-.77.73h-1.06v-1.428h1.06c.454 0 .77.305.77.698Zm2.763-2.375v7.283h2.536c2.088 0 3.682-1.563 3.682-3.672 0-2.071-1.596-3.611-3.682-3.611H9.58Zm4.44 3.611c0 1.159-.768 1.995-1.803 1.995h-.9v-3.93h.9c1.048 0 1.804.8 1.804 1.935Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M17 14.875h4.55v1.677h-2.814v1.216h2.512v1.677h-2.512v2.713H17v-7.283Z"
}));
exports.IconPdfFile = IconPdfFile;
//# sourceMappingURL=IconPdfFile.js.map